import { useCreateEventProcedure, useUpdateEventProcedure } from 'security-app/hooks/useEventProceduresAPI';
import type {
  CreateProcedurePayloadType,
  EventProceduresAPIType,
  EventProcedureStepAPIType,
} from 'security-app/hooks/api/eventProceduresAPI.types';

type HandleSubmitParams = {
  inValues: EventProceduresAPIType<Array<EventProcedureStepAPIType>> & { share_request?: any };
  eventProcedureId?: string;
  cb?: (eventProcedureId: string) => void;
};

function useFormActions() {
  const { createEventProcedure, creatingEventProcedure } = useCreateEventProcedure();
  const { updateEventProcedure, updatingEventProcedure } = useUpdateEventProcedure();

  const handleSubmit = ({ inValues, eventProcedureId = undefined, cb = undefined }: HandleSubmitParams) => {
    const newProcedure: CreateProcedurePayloadType = {
      title: inValues.title,
      description: inValues.description,
      steps: inValues.steps,
      share_request: inValues.share_request,
    };

    if (eventProcedureId) {
      updateEventProcedure({ eventProcedureId, eventProcedure: newProcedure }).then(() => cb?.(eventProcedureId));
    } else {
      createEventProcedure(newProcedure).then((createdProcedure) => {
        cb?.(createdProcedure?.id);
      });
    }
  };

  return { handleSubmit, saving: creatingEventProcedure || updatingEventProcedure };
}

export default useFormActions;
